import React, { Component } from "react";
import { Slide } from "react-reveal";

class Contact extends Component {
  render() {
    if (!this.props.data) return null;

    return (
      <section id="contact">

        <div className="row">
          <Slide left duration={1000}>
            <h2>References</h2>
            <p>
              <ul>
              <li><a href="https://pyserial.readthedocs.io/en/latest/tools.html#module-serial.tools.miniterm">• https://pyserial.readthedocs.io/en/latest/tools.html#module-serial.tools.miniterm</a></li>
              <li><a href="https://www.electronicwings.com/avr-atmega/atmega1632-usart">• https://www.electronicwings.com/avr-atmega/atmega1632-usart</a></li>
              <li><a href="http://foro.chesscc.com/viewtopic.php?f=15&t=4084">• http://foro.chesscc.com/viewtopic.php?f=15&t=4084</a></li>
              <li><a href="https://www.chess.com/forum/view/chess-equipment/making-my-automatic-chessboard">• https://www.chess.com/forum/view/chess-equipment/making-my-automatic-chessboard</a></li>
              <li><a href="http://fredjust.net/chessboard/">• http://fredjust.net/chessboard/</a></li>
              <li><a href="https://sites.google.com/view/berger-projects/en?authuser=0">• https://sites.google.com/view/berger-projects/en?authuser=0</a></li>
              <li><a href="https://create.arduino.cc/projecthub/Maxchess/wooden-chess-board-with-piece-recognition-872ffb">• https://create.arduino.cc/projecthub/Maxchess/wooden-chess-board-with-piece-recognition-872ffb</a></li>
              <li><a href="https://www.youtube.com/watch?v=VhKgAz2PJWU">• https://www.youtube.com/watch?v=VhKgAz2PJWU</a></li>
              <li><a href="http://people.ece.cornell.edu/land/courses/ece4760/FinalProjects/f2015/eh549_nds64/eh549_nds64/eh549_nds64/eh549_nds64.html">• http://people.ece.cornell.edu/land/courses/ece4760/FinalProjects/f2015/eh549_nds64/eh549_nds64/eh549_nds64/eh549_nds64.html</a></li>
              <li><a href="http://sishchess.blogspot.com/p/building-sish-board-tutorial.html">• http://sishchess.blogspot.com/p/building-sish-board-tutorial.html</a></li>
              <li><a href="http://chess.fortherapy.co.uk/home/">• http://chess.fortherapy.co.uk/home/</a></li>
              <li>• More references can be found in the <a href="docs/State of the Art(1210382-1210295).pdf">State of the Art</a> of this project.</li>
              </ul>
            </p>
          </Slide>
        </div>
      </section>
    );
  }
}

export default Contact;
